<template>
  <v-app id="app">
    <app-header/>
    <router-view></router-view>
    <app-footer/>
  </v-app>
</template>

<script>

export default {
  name: 'app',
  data () {
    return {
      drawer: false,
      items: [
        { title: 'news 1', link: 'link', date: '2018-09-09' },
        { title: 'news 2', link: 'link', date: '2018-09-09' },
        { title: 'news 3', link: 'link', date: '2018-09-09' },
        { title: 'news 4', link: 'link', date: '2018-09-09' },
        { title: 'news 4', link: 'link', date: '2018-09-09' },
        { title: 'news 4', link: 'link', date: '2018-09-09' }
      ]
    }
  }
}
</script>

<style>
  body.js-d-track-event-links {
    background: transparent !important;
  }

  h1, h2, h3, h4, p, a, span, blockquote {
    font-family: 'Fira Sans', sans-serif;
    line-height: 2;
  }
  .v-btn__content {
    font-family: 'Fira Sans', sans-serif;
  }
  h1 {
    font-size: 55px;
    font-weight: bold;
  }

  h2 {
    font-size: 48px;
    font-weight: 300;
  }

  h3 {
    font-size: 24px;
    margin-top: 0px;
  }

  h4 {
    font-size: 15px;
    font-style: italic;
    font-weight: lighter;
    margin-top: 0px;
  }

  p {
    font-weight: 400;
    font-size: 18px;
  }

  ul {
    padding: 0px;
    margin: 0px;
  }

  li {
    list-style: none;
  }

  a {
    color: #9BB5C2;
  }

  a.router-link-exact-active {
    color: #88C6BC;
  }

  .container {
    max-width: 960px;
    margin: 0px auto;
    padding: 20px;
  }
</style>
